import { Notify } from 'quasar';

export const showNoAccessNotification = () => {
    Notify.create({
        message: `You don't have access to this page. For any questions or assistance, please <a class="text-black" href='${import.meta.env.VITE_SUPPORT_CONTACT_URL}'>contact support</a>.`,
        classes: 'q-pa-md',
        icon: 'sym_o_error',
        iconColor: 'dark-red',
        textColor: 'black',
        color: 'light-red',
        position: 'top',
        timeout: 30000,
        actions: [
            { label: 'Dismiss', color: 'dark-red' },
        ],
        html: true,
    });
};
